import PackageBase from "../../views/Package/PackageBase.vue";
import PackageInfo from "../../views/Package/PackageInfo.vue";
import PackageContributors from "../../views/Package/PackageContributors.vue";
import PackageVersions from "../../views/Package/PackageVersions.vue";
import PackageDependencies from "../../views/Package/PackageDependencies.vue";
import PackageEdit from "../../views/Package/PackageEdit.vue";

export default {
  path: "/package/@:organizationSlug/:name/:versionName",
  component: PackageBase,
  props: true,
  children: [
    {
      path: "",
      name: "package_version_organization_info",
      component: PackageInfo
    },
    {
      path: "contributors",
      name: "package_version_organization_contributors",
      props: true,
      component: PackageContributors
    },
    {
      path: "versions",
      name: "package_version_organization_versions",
      props: true,
      component: PackageVersions
    },
    {
      path: "dependencies",
      name: "package_version_organization_dependencies",
      props: true,
      component: PackageDependencies
    },
    {
      path: "edit",
      name: "package_version_edit",
      component: PackageEdit,
      meta: {
        auth: true
      },
    }
  ]
};
